export default __webpack_public_path__ + "static/media/p7-13.059c4ca6.png";